import React from 'react';
import { SearchBtnWrap, SearchIcon } from './styled';
export var SearchBtn = function (_a) {
    var isInactive = _a.isInactive, onClick = _a.onClick;
    return (<SearchBtnWrap isInactive={!!isInactive} onClick={onClick}>
            <SearchIcon width='22' height='22' viewBox='0 0 22 22' fill='none' isInactive={!!isInactive}>
                <path d='M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z' stroke='#181B21' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                <path d='M22 22L20 20' stroke='#181B21' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
            </SearchIcon>
        </SearchBtnWrap>);
};
